export class ImageCarousel {
    constructor(img_gal_index){
        this.img_gal_index = img_gal_index;
        this.slide_index = 1;
    }

    openModal(loop_index) {
      let scroll_x = window.scrollX;
      let scroll_y = window.scrollY;
      window.scrollTo(scroll_x, scroll_y);
      document.getElementById(
          "myModal-" + this.img_gal_index
      ).style.display = "block";

      // Need to target specific slide
      let slides = document.getElementsByClassName(
          "mySlides-" + this.img_gal_index
      );
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      if(slides.length > 0) {
        slides[loop_index-1].style.display = "block";
      }
    }

    closeModal() {
      document.getElementById(
          "myModal-" + this.img_gal_index
      ).style.display = "none";
      // Need to reset style.display of slides
      let slides = document.getElementsByClassName(
          "mySlides-" + this.img_gal_index
      );
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      if(slides.length > 0) {
        slides[0].style.display = "block";
      }
    }

    plusSlides(n) {
      this.slide_index += n
      showSlides();
    }

    currentSlide(n) {
      this.slide_index = n
      showSlides();
    }

    showSlides() {
      var i;
      var slides = document.getElementsByClassName(
          "mySlides-" + this.img_gal_index
      );
      if (this.slide_index > slides.length) {
          this.slide_index = 1;
      }
      if (this.slide_index < 1) {
          this.slide_index = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      if(slides.length > 0) {
        slides[this.slide_index - 1].style.display = "block";
      }
    }
}
